import { Container } from 'react-bootstrap';

interface Props {
    children: React.ReactNode
}

export const Layout = ({ children }: Props): React.ReactElement<any, any> => {
    return (
        <Container fluid className='px-0 mb-5'>
            {children}
        </Container>
    );
};
